import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ITeam, ITeamsRequestParams } from './team.models';

import { convertObjectToRestapiParams } from 'src/app/utils/api.utils';

@Injectable()
export class TeamService {
    private _http = inject(HttpClient);

    /** Note that currently the TeamsRequestParams allows a leagueId array filter which exists in the API but doesn't currently do anything */
    public getTeamsApi(params: ITeamsRequestParams): Observable<ITeam[]> {
        return this._http.get<ITeam[]>(`teams`, {
            params: convertObjectToRestapiParams(params)
        });
    }
}
